var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultCompanyCoverImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1118,
    height: 350,
    viewBox: "0 0 1118 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1736_88030)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1118,
    height: 350,
    rx: 8,
    fill: "url(#paint0_linear_1736_88030)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5049,
    cy: 58.5049,
    r: 138.95,
    transform: "rotate(45 99.5049 58.5049)",
    fill: "url(#paint1_linear_1736_88030)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -7.81016,
    cy: 395.189,
    r: 109.566,
    transform: "rotate(-15 -7.81016 395.189)",
    fill: "url(#paint2_linear_1736_88030)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 990.667,
    cy: 318.668,
    r: 167.349,
    transform: "rotate(-135 990.667 318.668)",
    fill: "url(#paint3_linear_1736_88030)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.166,
    cy: 177.58,
    rx: 178.166,
    ry: 177.58,
    transform: "matrix(0.92579 -0.378038 -0.378038 -0.92579 910.264 172.511)",
    fill: "url(#paint4_linear_1736_88030)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1736_88030",
    x1: -0.00000968201,
    y1: 105.852,
    x2: 1187.13,
    y2: 300.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.140869,
    stopColor: "#006EFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798248,
    stopColor: "#7AB1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EEF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1736_88030",
    x1: 167.342,
    y1: 113.243,
    x2: -25.4097,
    y2: -8.39696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1736_88030",
    x1: 45.6814,
    y1: 438.352,
    x2: -106.308,
    y2: 342.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1736_88030",
    x1: 1072.37,
    y1: 384.593,
    x2: 840.222,
    y2: 238.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1736_88030",
    x1: 265.15,
    y1: 247.536,
    x2: 18.4611,
    y2: 91.3448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1736_88030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1118,
    height: 350,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCompanyCoverImage);
export default __webpack_public_path__ + "static/media/defaultCompanyCoverImage.cc50cbed3969a20bd6f333853bcf815f.svg";
export { ForwardRef as ReactComponent };